import React, { useEffect, useState } from "react"
import { api } from "../../app/Api/ApiSlice"
import { useParams } from "react-router-dom"
import { toast } from "react-toastify"
import InfiniteScroll from "react-infinite-scroll-component"
import Loader from "../../components/Loader"
import SuggestionMessage from "../../components/SuggestionMessage"

// component for showing a store/business suggestion box inbox

const StoreSuggestions = () => {
	const [suggestions, setSuggestions] = useState([])
	const [isLoading, setIsLoading] = useState(false)
	const [page, setPage] = useState(1)
	const [category, setCategory] = useState("all")
	const [hasMore,setHasMore] = useState(false)

	const { name } = useParams()

	useEffect(() => {
		const getSuggestions = async () => {
			try {
				setIsLoading(true)
				const response = await api.get(`/stores/${name}/suggestions`, { params: { page, category } })
				if (response) {
					setIsLoading()
					setSuggestions((prev) => [...prev, ...response.data])
				}
			} catch (error) {
				setIsLoading(false)
				toast.error(error.response.data.message)
			}
			finally { setIsLoading(false) }
		}

		getSuggestions()
	}, [])

//saving and deleting suggetions

	const handleRefresh = async()=>{}
	return (
		<div className="suggestion-box-wrapper">
			<h2 className="page-header-title">Suggestion box messages</h2>
			<div className="sugg-messages">
				<InfiniteScroll
					dataLength={suggestions.length}
					next={() => setPage((prev) => prev + 1)}
					hasMore={hasMore}
					refreshFunction={handleRefresh}
					Loader={<Loader />}
					pullDownToRefresh={true}
				>
					{!isLoading && suggestions.length ===0 && <p className="not-found-msg">suggestion box empty</p>}
					{
						suggestions.map((sugg)=>(
							<SuggestionMessage sugg={sugg}/>
						))
					}
				</InfiniteScroll>
			</div>
		</div>
	)
}

export default StoreSuggestions